<template>
  <section :class="section_class" v-if="assignment">
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  computed: {
    assignment() {
      return this.$store.state.assignment
    },
    section_class(){

      if (this.$route.path.endsWith("/video")){
        return "section video"
      } else {
        return "section"
      }
    }
  },

  mounted () {
    let slug = this.$route.params.assignment
    let that = this
    this.$store.dispatch('loadAssignments', slug)
      .then(() => {
        /*if (!that.assignment) {
          this.$store.dispatch('loadAssignment', slug)
          .then(() => {
            if (that.assignment.status == 'completed') {
              that.$router.push(`/assignment/${that.assignment.slug}/confirmation`)
            }
          })
        } else {
          if (that.assignment.status == 'completed') {
            that.$router.push(`/assignment/${that.assignment.slug}/confirmation`)
          }
        }*/

        if (that.assignment.status == 'completed') {
          that.$router.push(`/assignment/${that.assignment.slug}/confirmation`)
        }
      })
  }
}
</script>
<style>
  section.section {
    display: flex;
    width: 100%;
  }
  section.video {
    padding: 0!important;
  }
</style>
